import { Sim } from '../../game/simulation';
import { t } from '../strings';

/**
 * Transient hint / blocked-action toast. Subscribes to sim events.
 */
export class HintToast {
  private root: HTMLDivElement;
  private timer = 0;
  /** Last shown text + when. Rapid identical events (e.g. spamming a
   *  blocked drag-paint) used to restart the animation every frame and
   *  flicker; we now ignore re-show calls with the same text inside a
   *  short window. */
  private lastText = '';
  private lastShownAt = 0;

  constructor(parent: HTMLElement, sim: Sim) {
    this.root = document.createElement('div');
    this.root.className = 'ui-hint';
    parent.appendChild(this.root);

    sim.bus.on(e => {
      if (e.type === 'hint') this.show(e.text, !!e.warn);
      else if (e.type === 'blocked') this.show(e.reason, true);
      else if (e.type === 'leveledUp') this.show(t('hint.leveledUp', { level: e.level }));
    });

    this.show(t('hint.intro'));
  }

  update(dt: number) {
    if (this.timer > 0) {
      this.timer -= dt;
      if (this.timer <= 0) this.root.classList.remove('show');
    }
  }

  private show(text: string, warn = false) {
    const now = performance.now();
    // Identical text inside 600ms — keep the existing toast visible
    // (refresh its timer) but don't restart the CSS animation. This
    // squashes drag-paint blocked-event flicker.
    if (text === this.lastText && now - this.lastShownAt < 600) {
      this.timer = 3.5;
      this.lastShownAt = now;
      return;
    }
    this.lastText = text;
    this.lastShownAt = now;
    this.root.textContent = text;
    this.root.classList.toggle('warn', warn);
    this.root.classList.add('show');
    this.timer = 3.5;
  }
}
